import { FormattedUnits } from "#src/components/formatted-units";

import * as sx from "./index.sx";

export function Value({
  value,
  units,
}: {
  value: number | string;
  units?: string;
}) {
  return (
    <>
      <sx.Value>{value}</sx.Value>
      {units ? (
        <sx.Units>
          <FormattedUnits units={units ?? ""} />
        </sx.Units>
      ) : null}
    </>
  );
}
